import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { type ProductsSearchDatum } from 'domains/products/components/search/utils/types'

type Props = Pick<
  ProductsSearchDatum,
  'departments' | 'aisles' | 'primaryDepartmentId' | 'primaryAisleId'
>

export const ProductsSearchTableDeptAisleCell: FunctionComponent<Props> = ({
  departments,
  aisles,
  primaryDepartmentId,
  primaryAisleId,
}) => {
  const department = departments?.find(({ id }) => id === primaryDepartmentId)
  const aisle = aisles?.find(({ id }) => id === primaryAisleId)

  return <Text>{department ? `${department.name} / ${aisle?.name ?? '-'}` : '-'}</Text>
}
